import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'normalize.css/normalize.css';
import 'vant/lib/index.less'
import './utils/rem.js'; // 引入REM设置
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import * as filter from '@/filters'
import { Toast } from 'vant';
import {dayjsFormat} from "@/utils";
import "@/utils/preventReClick";

require('dayjs/locale/zh-cn')

dayjs.extend(duration);
dayjs.extend(isSameOrAfter)
dayjs.locale('zh-cn')

// 将dayjs添加到Vue原型链上
Vue.prototype.$dayjs = dayjs;
Vue.prototype.$dayjsFormat = dayjsFormat;
Vue.prototype.$bus = new Vue();

Vue.config.productionTip = false

Object.keys(filter).forEach(key => {
  Vue.filter(key, filter[key]);
})
Vue.directive('focus', {
  inserted: function(el) {
    el.focus()
  }
})



Vue.use(Toast);

// 在 main.js 或其他适当的初始化文件中
Vue.config.errorHandler = function (err, vm, info) {
  // 这里不进行任何操作，或者只记录到控制台
  console.error(err, vm, info);
  // 可以在这里发送错误报告到服务器
  // return false; // 可选：返回 false 可以阻止错误传递到其他监听器
};

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
